import useQueryURL from '../../../../../common/hooks/useQueryURL';
import ButtonPlus from '../../../../../common/components/atom/ButtonPlus/ButtonPlus';
import { useAuth } from '../../../../auth/hooks';
import { userRoles } from '../../../../user/types/user.types';

export interface AddNewChargeBtnProps {
    modalId?: string;
    onClick?: () => void;

}

/**
 * AddNewChargeBtn
 * 
 * 
 * @param param0 
 * @returns 
 */
export default function AddNewChargeBtn({modalId}: AddNewChargeBtnProps) {

    const modalIdFound = modalId || "add-new-charge-point-modal"
    const {setQueryValue} = useQueryURL()
    const {userRole} = useAuth()
    const handleOnClick = () => {
        setQueryValue({
            [modalIdFound]: "true"
        } )
    }

    if (!userRole || userRole < userRoles.ADMIN){
        return <></>
    }


    return (
        <ButtonPlus label="Ajouter une borne" onClick={handleOnClick}/>
    )
}
